// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const ETocochromanols = {
  productCode: "SBOVZ-E-TCCM",
  productName: "E Tocochromanols",
  ingredients: "Dehulled Sunflower seeds, De-colored annatto kernel, Green Tea",
  overview:"Orgavitaz-E as Tocochromanols is a standardized extract blend of Organic sunflower seed kernel, De-colored Annatto seed kernel and Sencha type Green Tea as core ingredients that brings together a judicious mix of Tocochromanols which are the most effective group of lipophilic phenolic antioxidants representing 10 vitamers of Vitamin E. ",
  assay:"Total Tocochromanols 15 % (both tocopherols and tocotrienols)",
  coNutrients:" Incidental nutrients include Phytosterols, omega fatty acids, natural folate, minerals and flavonoids (not a claim)",
  studies:"Comprehensive Stability and oxidative studies, Cell-assays for antioxidant properties, comparative studies to understand the benefits over synthetic humectant.",
  benefits:"Vitamin E promotes membrane repair by preventing the formation of oxidised phospholipids that theoretically might interfere with the membrane fusion events. It protects cells from damage, and aid in lowering a variety of health problems, from heart disease to cancer through its powerful anti-oxidant activity. Production of hormone-like substances that regulate a variety of body processes, including blood pressure, reproduction and muscle contraction. Vitamin E is vital to a functioning immune system. Vitamin E can also protect eye sight in a long-term risk of age-related cataracts. ",
  functionalUse: {
    main: "💊︎ Capsule, 🍚︎ Foods, 🥛︎ Beverages, 🚰︎ ORS, ⊘ Tablets (sensitive), 🍞︎ Baking,  🧂︎ Seasonings, 🍨︎ ice creams",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForDeficiencies/E-Tocochromanols/ET-1.png",
    "images/Portfolio/OrgavitazForDeficiencies/E-Tocochromanols/ET-2.png",
    "images/Portfolio/OrgavitazForDeficiencies/E-Tocochromanols/ET-3.png",
    "images/Portfolio/OrgavitazForDeficiencies/E-Tocochromanols/ET-4.png",
    "images/Portfolio/OrgavitazForDeficiencies/E-Tocochromanols/ET-5.png",
    "images/Portfolio/OrgavitazForDeficiencies/E-Tocochromanols/ET-6.png",



  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default ETocochromanols;
